import DashboardTypes from './dashboard.types';

export const dashboardStart = (data: any) => ({
	type: DashboardTypes.DASHBOARD_START,
	payload: data,
});

export const dashboardSuccess = (data: any) => ({
	type: DashboardTypes.DASHBOARD_SUCCESS,
	payload: data,
});

export const dashboardFailure = (error: unknown) => ({
	type: DashboardTypes.DASHBOARD_FAILURE,
	payload: error,
});

export const dashboardResponseChanged = () => ({
	type: DashboardTypes.DASHBOARD_RESPONSE_CHANGED,
});

export const dashboardResponseRestStart = () => ({
	type: DashboardTypes.DASHBOARD_RESPONSE_REST_START,
});

export const getPendingLeaveRequestsStart = (data: any) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_START,
	payload: data,
});

export const getPendingLeaveRequestsSuccess = (data: any) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_SUCCESS,
	payload: data,
});

export const getPendingLeaveRequestsFailure = (error: unknown) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_FAILURE,
	payload: error,
});

export const getPendingLeaveRequestsResponseChanged = () => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_RESPONSE_CHANGED,
});

export const getPendingLeaveRequestsResponseRestStart = () => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_RESPONSE_REST_START,
});

// Enhanced Employee List Actions
export const employeeListEnhancedStart = (data: any) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_START,
	payload: data,
});

export const employeeListEnhancedSuccess = (data: any) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_SUCCESS,
	payload: data,
});

export const employeeListEnhancedFailure = (error: unknown) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_FAILURE,
	payload: error,
});

export const employeeListEnhancedResponseChanged = () => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED,
});

export const employeeListEnhancedResponseRestStart = () => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START,
});

// Dashboard Card Actions
export const getActiveEmployeesCardStart = (data: any) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_START,
	payload: data,
});

export const getActiveEmployeesCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_SUCCESS,
	payload: data,
});

export const getActiveEmployeesCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_FAILURE,
	payload: error,
});

export const getCheckedInCardStart = (data: any) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_START,
	payload: data,
});

export const getCheckedInCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_SUCCESS,
	payload: data,
});

export const getCheckedInCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_FAILURE,
	payload: error,
});

export const getLateCheckInCardStart = (data: any) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_START,
	payload: data,
});

export const getLateCheckInCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_SUCCESS,
	payload: data,
});

export const getLateCheckInCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_FAILURE,
	payload: error,
});

export const getEarlyCheckOutCardStart = (data: any) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_START,
	payload: data,
});

export const getEarlyCheckOutCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_SUCCESS,
	payload: data,
});

export const getEarlyCheckOutCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_FAILURE,
	payload: error,
});

export const getOnLeaveCardStart = (data: any) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_START,
	payload: data,
});

export const getOnLeaveCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_SUCCESS,
	payload: data,
});

export const getOnLeaveCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_FAILURE,
	payload: error,
});

export const getAbsentCardStart = (data: any) => ({
	type: DashboardTypes.GET_ABSENT_CARD_START,
	payload: data,
});

export const getAbsentCardSuccess = (data: any) => ({
	type: DashboardTypes.GET_ABSENT_CARD_SUCCESS,
	payload: data,
});

export const getAbsentCardFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ABSENT_CARD_FAILURE,
	payload: error,
});

// Checked In Card Employee List Actions
export const getCheckedInCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getCheckedInCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getCheckedInCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getCheckedInCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getCheckedInCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});

// Active Employees Card Employee List Actions
export const getActiveEmployeesCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getActiveEmployeesCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getActiveEmployeesCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getActiveEmployeesCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getActiveEmployeesCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});

// Late Check In Card Employee List Actions
export const getLateCheckInCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getLateCheckInCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getLateCheckInCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getLateCheckInCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getLateCheckInCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});

// Early Check Out Card Employee List Actions
export const getEarlyCheckOutCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getEarlyCheckOutCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getEarlyCheckOutCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getEarlyCheckOutCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getEarlyCheckOutCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});

// On Leave Card Employee List Actions
export const getOnLeaveCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getOnLeaveCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getOnLeaveCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getOnLeaveCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getOnLeaveCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});

// Absent Card Employee List Actions
export const getAbsentCardEmployeeListStart = (data: any) => ({
	type: DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_START,
	payload: data,
});

export const getAbsentCardEmployeeListSuccess = (data: any) => ({
	type: DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_SUCCESS,
	payload: data,
});

export const getAbsentCardEmployeeListFailure = (error: unknown) => ({
	type: DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getAbsentCardEmployeeListResponseChanged = () => ({
	type: DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED,
});

export const getAbsentCardEmployeeListResponseRestStart = () => ({
	type: DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START,
});